'use client';

import React__default, { useState, useRef, useEffect } from 'react';
import '../_virtual/_tslib.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';

/**
 * @author ThienTD
 * @since Oct 19, 2024
 *
 * This component is used for lazyload element which is being
 * outside of viewport
 *
 * @param props ILazyloadCSRProps
 * @returns LazyloadCSR
 */
var LazyloadCSR = function (props) {
    var _a = useState(false), isRendered = _a[0], setIsRendered = _a[1];
    var divRef = useRef(null);
    var isElementOnScreen = useElementOnScreen({
        target: divRef
    })[0];
    useEffect(function () {
        if (!isElementOnScreen) {
            return;
        }
        // Once it rendered then it should be render
        // for the rest of time
        if (!isRendered) {
            setIsRendered(true);
        }
    }, [isRendered, isElementOnScreen]);
    return React__default.createElement("div", { ref: divRef }, isRendered ? props.children : null);
};

export { LazyloadCSR as default };
//# sourceMappingURL=index.js.map
